import { environment } from '../../../environments/environment';

/**
 * Builds Okta `/authorize` extra params such as audience for API access tokens.
 */
export function buildOktaAuthorizeExtraParams(): Record<string, string> | undefined {
  const audience = environment.okta.audience.trim();
  if (!audience) {
    return undefined;
  }

  return { audience };
}
